// Converte il contenuto degli articoli Steam in HTML sicuro.
// Steam usa due formati: BBCode (annunci ufficiali) e HTML grezzo (SteamDB).
// - BBCode: prima escapa TUTTO, poi abilita solo i tag noti.
// - HTML: sanifica con DOMPurify mantenendo solo una whitelist.
import DOMPurify from "dompurify";

const HTML_ALLOWED = {
  ALLOWED_TAGS: ["a", "img", "p", "br", "hr", "h1", "h2", "h3", "h4", "h5", "strong", "b", "em", "i", "u", "s",
    "blockquote", "code", "pre", "ul", "ol", "li", "table", "thead", "tbody", "tr", "td", "th", "span", "div"],
  ALLOWED_ATTR: ["href", "src", "alt", "target", "rel", "loading"],
};

export function steamMarkupToHtml(input) {
  const raw = input || "";
  const looksLikeHtml = /<(a|img|p|ol|ul|li|h[1-5]|table|div|span|br)\b/i.test(raw);
  if (looksLikeHtml) {
    const clean = DOMPurify.sanitize(raw, HTML_ALLOWED);
    // forza target _blank e rel sui link esterni
    return clean.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
  }

  let s = raw
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
  s = s.replace(/\[url=([^\]]+)\]([\s\S]*?)\[\/url\]/gi, '<a href="$1" target="_blank" rel="noopener noreferrer">$2</a>');
  s = s.replace(/\[url\]([\s\S]*?)\[\/url\]/gi, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
  s = s.replace(/\[dynamiclink href="([^"]+)"\]([\s\S]*?)\[\/dynamiclink\]/gi, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
  s = s.replace(/\[previewyoutube=([^;\]]+)[^\]]*\]([\s\S]*?)\[\/previewyoutube\]/gi, '<a href="https://youtu.be/$1" target="_blank" rel="noopener noreferrer">Guarda il video su YouTube</a>');
  s = s.replace(/\[img\]([\s\S]*?)\[\/img\]/gi, '<img src="$1" alt="" loading="lazy" />');
  s = s.replace(/\[p\]([\s\S]*?)\[\/p\]/gi, "<p>$1</p>");
  s = s.replace(/\[h1\]([\s\S]*?)\[\/h1\]/gi, "<h3>$1</h3>");
  s = s.replace(/\[h2\]([\s\S]*?)\[\/h2\]/gi, "<h4>$1</h4>");
  s = s.replace(/\[h3\]([\s\S]*?)\[\/h3\]/gi, "<h5>$1</h5>");
  s = s.replace(/\[b\]([\s\S]*?)\[\/b\]/gi, "<strong>$1</strong>");
  s = s.replace(/\[i\]([\s\S]*?)\[\/i\]/gi, "<em>$1</em>");
  s = s.replace(/\[u\]([\s\S]*?)\[\/u\]/gi, "<u>$1</u>");
  s = s.replace(/\[strike\]([\s\S]*?)\[\/strike\]/gi, "<s>$1</s>");
  s = s.replace(/\[quote(?:=[^\]]*)?\]([\s\S]*?)\[\/quote\]/gi, "<blockquote>$1</blockquote>");
  s = s.replace(/\[code\]([\s\S]*?)\[\/code\]/gi, "<code>$1</code>");
  s = s.replace(/\[hr\]/gi, "<hr />");
  s = s.replace(/\[table\]([\s\S]*?)\[\/table\]/gi, "<table>$1</table>");
  s = s.replace(/\[tr\]([\s\S]*?)\[\/tr\]/gi, "<tr>$1</tr>");
  s = s.replace(/\[t[dh]\]([\s\S]*?)\[\/t[dh]\]/gi, "<td>$1</td>");
  s = s.replace(/\[list\]([\s\S]*?)\[\/list\]/gi, (m, inner) => {
    const items = inner.split("[*]").filter((x) => x.trim());
    return `<ul>${items.map((x) => `<li>${x.trim()}</li>`).join("")}</ul>`;
  });
  s = s.replace(/\[olist\]([\s\S]*?)\[\/olist\]/gi, (m, inner) => {
    const items = inner.split("[*]").filter((x) => x.trim());
    return `<ol>${items.map((x) => `<li>${x.trim()}</li>`).join("")}</ol>`;
  });
  // rimuove eventuali tag sconosciuti rimasti
  s = s.replace(/\[\/?[^\]]*\]/g, "");
  // paragrafi e a-capo
  s = s.replace(/\n{2,}/g, "<br /><br />").replace(/\n/g, "<br />");
  return s;
}
